module.exports = __webpack_public_path__ + "static/media/logo-1.6352f7a1.png";